import axios from 'axios'
import config from '@/config/env'

const { API_URL } = config

const loadProjects = (params) => {
  const query = params

  if (params?.querysearch) {
    const cancelled = params.querysearch.find((e) => e.includes('CANCELLED'))
    if (!cancelled) {
      query.querysearch.push('state:ne(CANCELLED)')
    }
  } else {
    query.querysearch = ['state:ne(CANCELLED)']
  }

  let sort = `desc(idproject)`
  if (params?.sort) {
    sort = params.sort
  }

  return axios.get(API_URL + '/entproject', { params: { ...query, sort } })
}

const loadOwnEnterpriseProjects = (params) => {
  const query = params

  return axios.get(API_URL + '/entproject/searchownenterprise', {
    params: query,
  })
}

const loadProject = (idproject) => {
  return axios.get(API_URL + '/entproject', {
    params: {
      querysearch: `idproject:eq(${idproject})`,
      fetch: [
        'identerprise.idaddress',
        'idsigner.idadministrator',
        'idmerchant.identerprise',
        'idproventer.idmerchant',
      ],
    },
  })
}

const createProject = (request) => {
  return axios.post(API_URL + '/entproject', request, {})
}

const createProjectOperator = (request) => {
  return axios.post(API_URL + '/entproject/createprojectoperator', request, {})
}

const changeState = (project) => {
  return axios.post(API_URL + '/entproject/changestatusproject', project)
}

const getProjectEvaluation = (idproject) => {
  return axios.get(API_URL + '/entproject/getevaluation', {
    params: {
      idproject: idproject,
    },
  })
}

const getEvaluationJSON = (idproject) => {
  return axios.get(API_URL + '/entproject/getevaluationjson', {
    params: {
      idproject: idproject,
    },
  })
}

const getProductQuotas = (params) => {
  return axios.get(API_URL + '/entproject/getquotas', {
    params,
  })
}

const getHistory = (idproject) => {
  return axios.get(API_URL + '/entproject/gethistory/' + idproject)
}

const getPropertyInfo = (identerprise) => {
  return axios.get(`${API_URL}/entpropertyinf/project/${identerprise}`)
}

const getProjectconfig = (identerprise) => {
  return axios.get(`${API_URL}/entprojectconfig/project/${identerprise}`)
}

const saveDataProject = (dataChangeProject) => {
  return axios.put(API_URL + '/entproject/data', dataChangeProject)
}

const assignMerchant = (params) => {
  return axios.put(API_URL + '/entproject/assignmerchant', params)
}

const changeMotive = (project) => {
  return axios.post(API_URL + '/entproject/changemotive', project)
}

const api = {
  loadProjects,
  loadOwnEnterpriseProjects,
  loadProject,
  createProject,
  createProjectOperator,
  changeState,
  getProjectEvaluation,
  getEvaluationJSON,
  getHistory,
  getPropertyInfo,
  getProjectconfig,
  getProductQuotas,
  saveDataProject,
  assignMerchant,
  changeMotive,
}

export default api
